/**
 * LadyBae livesearch fix v3
 * Shopify /search/suggest* returns 417 "Unsupported buyer locale" on this shop.
 * Fallback: /search?q=...&type=product&section_id=lb-search-suggest (full search works).
 */
(function () {
  if (window.__lbLivesearchFixV3) return;
  window.__lbLivesearchFixV3 = true;

  var DEBOUNCE_MS = 180;
  var LIMIT = 8;
  var timer = null;
  var seq = 0;

  function money(raw) {
    if (raw == null || raw === '') return '';
    var n = typeof raw === 'string' ? parseFloat(raw.replace(/,/g, '')) : Number(raw);
    if (!isFinite(n)) return String(raw);
    try {
      return new Intl.NumberFormat('zh-TW', {
        style: 'currency',
        currency: 'TWD',
        maximumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + Math.round(n);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function productUrl(p) {
    if (p.url) return p.url;
    if (p.handle) return '/products/' + p.handle;
    return '/search?q=' + encodeURIComponent(p.title || '') + '&type=product';
  }

  function imgHtml(p) {
    var src =
      (typeof p.image === 'string' && p.image) ||
      (p.image && (p.imageUrl || p.image.src || p.image)) ||
      (p.featured_image && (p.featured_image.url || p.featured_image.src || p.featured_image)) ||
      '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return (
      '<figure><picture><img src="' +
      esc(src) +
      '" alt="" width="70" height="71" loading="lazy"></picture></figure>'
    );
  }

  function renderMarkup(term, products) {
    var q = String(term || '').trim();
    var viewAll =
      '<p class="mobile-hide"><a href="/search?q=' +
      encodeURIComponent(q) +
      '&type=product" class="strong">查看所有結果&nbsp;<i aria-hidden="true" class="icon-chevron-right"></i></a></p>';
    var head =
      '<div class="cols"><p>搜尋結果「' +
      esc(q) +
      '」</p>' +
      viewAll +
      '</div>';

    if (!products || !products.length) {
      return (
        head +
        '<p class="lb-livesearch-empty">找不到符合的課程／商品。請按 Enter 查看完整搜尋結果。</p>' +
        '<p class="mobile-only"><a href="/search?q=' +
        encodeURIComponent(q) +
        '&type=product" class="strong">查看所有結果</a></p>'
      );
    }

    var items = products
      .map(function (p) {
        var title = p.title || '';
        var price = p.price != null ? money(p.price) : p.price_min != null ? money(p.price_min) : '';
        var noImg = imgHtml(p) ? '' : ' no-img';
        return (
          '<li class="' +
          noImg +
          '">' +
          imgHtml(p) +
          '<section><div class="cols"><h2><a href="' +
          esc(productUrl(p)) +
          '">' +
          esc(title) +
          '</a></h2>' +
          (price ? '<p class="price s1pr">' + esc(price) + '</p>' : '') +
          '</div></section></li>'
        );
      })
      .join('');

    return (
      head +
      '<ul class="l4ca compact lb-livesearch-products">' +
      items +
      '</ul>' +
      '<p class="mobile-only"><a href="/search?q=' +
      encodeURIComponent(q) +
      '&type=product" class="strong">查看所有結果</a></p>'
    );
  }

  function ensurePanelVisible(form) {
    if (!form) return;
    document.documentElement.classList.add(
      'search-compact-active',
      'search-full',
      'search-full-mode',
      'search-focus'
    );
    form.classList.add('full', 'has-text', 'not-empty');
    try {
      if (typeof window.new_css === 'function' && window.filepaths) {
        window.new_css('css-search', window.filepaths.async_search_css);
      }
    } catch (e) {}
  }

  function setLivesearchHtml(html) {
    var el = document.getElementById('livesearch');
    var form = document.getElementById('search');
    if (!el) return;
    ensurePanelVisible(form);
    el.innerHTML = html;
    el.hidden = false;
    el.removeAttribute('hidden');
    if (form) form.classList.remove('processing');
  }

  function extractSectionById(text, id) {
    if (!text) return null;
    try {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var section =
        doc.querySelector('#shopify-section-' + id) ||
        doc.querySelector('[id^="shopify-section-"][id*="' + id + '"]');
      if (section && section.innerHTML && section.innerHTML.trim()) return section.innerHTML;
    } catch (e) {}
    return null;
  }

  function parseProductsFromSearchHtml(text) {
    var products = [];
    try {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var cards = doc.querySelectorAll(
        'a[href*="/products/"], .l4ca a[href*="/products/"], [data-product-id] a[href*="/products/"]'
      );
      var seen = {};
      Array.prototype.forEach.call(cards, function (a) {
        var href = a.getAttribute('href') || '';
        if (!/\/products\//.test(href) || seen[href]) return;
        var title = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (!title || title.length < 2) return;
        seen[href] = true;
        products.push({ title: title, url: href });
      });
    } catch (e) {}
    return products.slice(0, LIMIT);
  }

  function fetchSuggestJson(term) {
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources%5Btype%5D=product&resources%5Blimit%5D=' +
      LIMIT;
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('suggest.json ' + res.status);
      return res.json();
    });
  }

  /** Primary working path on this shop (suggest* is 417 locale). */
  function fetchSearchSection(term) {
    var url =
      '/search?q=' +
      encodeURIComponent(term) +
      '&type=product&section_id=lb-search-suggest';
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (res) {
      if (!res.ok) throw new Error('search section ' + res.status);
      return res.text();
    });
  }

  function fetchSearchPage(term) {
    var url = '/search?q=' + encodeURIComponent(term) + '&type=product';
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('search page ' + res.status);
      return res.text();
    });
  }

  function runSearch(term) {
    var q = String(term || '').trim();
    var form = document.getElementById('search');
    if (!q) {
      if (form) form.classList.remove('processing', 'has-text', 'not-empty', 'full');
      return;
    }
    ensurePanelVisible(form);
    setLivesearchHtml(
      '<div class="cols"><p>搜尋結果「' +
        esc(q) +
        '」</p></div><p class="lb-livesearch-empty">搜尋中…</p>'
    );
    if (form) form.classList.add('processing');

    var my = ++seq;

    function applySectionOrThrow(text) {
      var html = extractSectionById(text, 'lb-search-suggest');
      if (html && (html.indexOf('lb-livesearch-products') >= 0 || html.indexOf('lb-livesearch-empty') >= 0 || html.indexOf('/products/') >= 0)) {
        setLivesearchHtml(html);
        return true;
      }
      return false;
    }

    // 1) Prefer full-search section (works despite suggest 417)
    fetchSearchSection(q)
      .then(function (text) {
        if (my !== seq) return;
        if (applySectionOrThrow(text)) return;

        // 2) Try predictive JSON (in case Markets locale gets fixed)
        return fetchSuggestJson(q)
          .then(function (data) {
            if (my !== seq) return;
            var products = (((data || {}).resources) || {}).products || [];
            if (products.length) {
              setLivesearchHtml(renderMarkup(q, products));
              return;
            }
            throw new Error('empty suggest');
          })
          .catch(function () {
            if (my !== seq) return;
            // 3) Parse full search HTML as last resort
            return fetchSearchPage(q).then(function (pageHtml) {
              if (my !== seq) return;
              var products = parseProductsFromSearchHtml(pageHtml);
              setLivesearchHtml(renderMarkup(q, products));
            });
          });
      })
      .catch(function () {
        if (my !== seq) return;
        return fetchSuggestJson(q)
          .then(function (data) {
            if (my !== seq) return;
            var products = (((data || {}).resources) || {}).products || [];
            setLivesearchHtml(renderMarkup(q, products));
          })
          .catch(function () {
            if (my !== seq) return;
            return fetchSearchPage(q)
              .then(function (pageHtml) {
                if (my !== seq) return;
                var products = parseProductsFromSearchHtml(pageHtml);
                setLivesearchHtml(renderMarkup(q, products));
              })
              .catch(function () {
                if (my !== seq) return;
                setLivesearchHtml(
                  '<div class="cols"><p>搜尋結果「' +
                    esc(q) +
                    '」</p></div><p class="lb-livesearch-empty">暫時無法載入建議結果。請按 Enter 查看完整搜尋頁。</p>'
                );
              });
          });
      });
  }

  function schedule(term) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      runSearch(term);
    }, DEBOUNCE_MS);
  }

  function isSearchInput(el) {
    return !!(
      el &&
      (el.id === 'search_main' || (el.name === 'q' && el.closest && el.closest('#search')))
    );
  }

  function onTyped(input) {
    var form =
      document.getElementById('search') || (input && input.closest && input.closest('#search'));
    if (!form || form.classList.contains('no-autocomplete')) return;
    var v = ((input && input.value) || '').trim();
    if (!v) {
      form.classList.remove('processing');
      return;
    }
    ensurePanelVisible(form);
    schedule(v);
  }

  document.addEventListener(
    'input',
    function (e) {
      if (isSearchInput(e.target)) onTyped(e.target);
    },
    true
  );
  document.addEventListener(
    'keyup',
    function (e) {
      if (isSearchInput(e.target)) onTyped(e.target);
    },
    true
  );

  var neutralizeTries = 0;
  var neutralizeIv = setInterval(function () {
    neutralizeTries += 1;
    if (typeof window.getSearchResults === 'function' && !window.getSearchResults.__lbPatched) {
      window.getSearchResults = function (searchTerm) {
        schedule(searchTerm);
      };
      window.getSearchResults.__lbPatched = true;
    }
    if (typeof window.liveSearch === 'function' && !window.liveSearch.__lbPatched) {
      window.liveSearch = function (elem) {
        schedule(elem && elem.value != null ? elem.value : '');
      };
      window.liveSearch.__lbPatched = true;
    }
    if (neutralizeTries > 60) clearInterval(neutralizeIv);
  }, 200);
})();
